import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import {
  Container as SecondaryContainer,
  Headline as SecondaryHeadline,
} from "scmp-app/components/content/content-item-render/variants/home-secondary-v2/styles";
import { SeriesShortLabelLink } from "scmp-app/components/content/content-series-short-label/styles";
import { HomeV2TopStoriesItem } from "scmp-app/components/home-v2/top-stories-item";

export const StyledHeroArticle = styled(HomeV2TopStoriesItem)`
  ${SeriesShortLabelLink} {
    font-weight: 700;
  }

  ${SecondaryHeadline} {
    font-size: 20px;
  }

  ${SecondaryContainer} {
    ${theme.breakpoints.up("tablet")} {
      grid-template-columns: 0.4fr 0.6fr;
      column-gap: 20px;
    }
  }
`;
